module.exports = __webpack_public_path__ + "img/flutkatastrophe.f35507ba.png";